import React, { Component } from 'react';
import './about.scss'
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { message } from 'antd';
import 'antd/dist/antd.css';


class about extends Component {

    state = {
        banner:[],
        currentIndex:0,
        list:[{},{},{},{},{},{},{},{},{},{},{},{}],
        arr:[{},{},{},{},{},{},{},{},{},{}],
        account:"",
        phone:"",
        opinion:"",
        evaluate:[],
        new:[],
        area:[],
        image:"",
        data:{},
    }

    

    componentWillMount(){
        window.scroll(0,0);
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    onChange=(index)=>{
        this.setState({
            currentIndex:index
        })
    }

    gotoSlide=(num)=>{
        this.refs['bslide'].goTo(num);
    }

    gotoUrl=(data)=>{
        let url = data.url;
        window.open(url);
    }

    render() {
        return (
            <div className="about">
                <Header type={12}></Header>
                <div className="h_page2">
                    

                    <div className='hinfo'  style={{backgroundImage:"url('/www/assets/imgs/guanyuwomenbeijing.png')"}}>
                        <div className='cen'>
                            <div className='hmark'>
                                <h1>关于我们</h1>
                                <p>ABOUT  US</p>
                                <div className='cen'>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                        <div className='cen'>
                            <div className='htext'>
                                {/* <div className='himg' style={{backgroundImage:"url('"+this.state.data.image+"')"}}></div> */}
                                <div className='hright'>
                                    <h1>灵氪科技产业服务平台主要面向各地政府及产业园区，旨在打造信息互联渠道，设立专家库、人才库、企业库、政策库、成果库等公共创新资源库，通过数据共享、资源互通，充分发挥规模经济的作用，降低企业科技创新成本。</h1>
                                    <h1>平台致力于成为产业创新集群的推动者、关键技术攻关的组织者、创新资源要素的整合者、科技产业决策的参谋者，助力政府及园区打造新兴产业培育典范。</h1>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='cen'>
                        <div className='aname'>
                            <img alt="" src="/www/assets/imgs/lei.png" />
                            <h2><span>公司名称：</span>深圳伊灵灵伊科技有限公司</h2>
                        </div>
                    </div>
                    <div className='cen'>
                        <div className='aname'>
                            <img alt="" src="/www/assets/imgs/lei.png" />
                            <h2><span>办公地址：</span>深圳市南山区粤海街道高新区社区科技南八路2号豪威科技大厦13FC03</h2>
                        </div>
                    </div>
                    <div className='cen'>
                        <div className='aname'>
                            <img alt="" src="/www/assets/imgs/lei.png" />
                            <h2><span>合作/反馈：</span>ylly_1001@163.com</h2>
                        </div>
                    </div>
                    <div className='cen'>
                        <div className='aname'>
                            <img alt="" src="/www/assets/imgs/lei.png" />
                            <h2><span>联系电话：</span>010-62769088</h2>
                        </div>
                    </div>
                </div>

                <Footer></Footer>
            </div>
        );
    }
}

export default about;